import { render, staticRenderFns } from "./purchase-order.vue?vue&type=template&id=377cbd4b"
import script from "./purchase-order.vue?vue&type=script&lang=js"
export * from "./purchase-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports